export const gapiConfig = {
  api: "AIzaSyAE5FoAidmDdR5prBcjWDXQUMT0z6S89XM",
  client:
    "1008967257162-eif7kcf5b4t2o5pi223fp1u96h7efel2.apps.googleusercontent.com",
  scopes: ["profile"],
};
